import React, { useMemo } from "react";
import MainDropDown from "../../../dropDown/MainDropDown";
import RadioButton from "../../../radioButton/SquareRadioButton";
import MainInput from "../../../input";



const defaultSourceOptions = [
  { label: "ACU", value: 0, isDisabled: false },
]
const defaultConditionOptions = [
  { label: "close", value: 0, isDisabled: false },
  { label: "open", value: 1, isDisabled: false },
  { label: "change", value: 2, isDisabled: false },
]
const defaultOutputsOptions = [
  { label: "1", value: 0, isDisabled: false },
  { label: "2", value: 1, isDisabled: false },
]
const defaultRelayModeOptions = [
  { label: "Trigger", value: 0, isDisabled: false },
  { label: "Impulse", value: 1, isDisabled: false },
]
const defaultTypeOptions = [
  { label: "NO", value: 0, isDisabled: false },
  { label: "NC", value: 1, isDisabled: false },
]


const OutputType = ({ source, selectedPorts, setSelectedPorts,
  componentsSourceOptions = defaultSourceOptions, component_source,
  output, name, selectOptions,
  relayModeOptions = defaultRelayModeOptions, relay_mode = 0, impulse_time, entry_exit_open_durations,
  typeOptions = defaultTypeOptions, sensorAutolock, fieldsData
}) => {
  const outputsOptions = useMemo(() => {
    const data = [];

    if (component_source === 0) {
      for (const property in fieldsData.outputs_info) {
        data.push({
          label: fieldsData.outputs_info[property].name, value: property,
          isDisabled: selectedPorts["output"][component_source] ? !!selectedPorts["output"][component_source][property] : false
        })
      }

    } else {
      for (let i = 0; i < source.outputsPortCount; i++) {
        data.push({
          label: `${i + 1}`,
          value: i + 1,
          isDisabled: selectedPorts["output"][component_source] ? !!selectedPorts["output"][component_source][i + 1] : false
        })
      }
    }

    return data.length ? data : defaultOutputsOptions
  }, [fieldsData, component_source, selectedPorts])


  const componentSourceOptions = useMemo(() => {
    const data = [];

    return source.outputs.length ? source.outputs : defaultSourceOptions
  }, [source])

  const impulseDurationValidation = (input) => {
    const regex = /^([0-2](\.\d?)?)?$/; // Adjusted regex for "0." case
    return regex.test(input);
  }

  const validateNumberRange = (input) => {
    // Ensure input is a valid number and within the range 0 to 60
    const number = Number(input);
    return input === "" || (!isNaN(number) && number >= 0 && number <= 60);
  };
  return <div className="lock-group-dropdown-container">
    <div className="single-dropdown-container">
      <span>Component Source</span>
      <MainDropDown
        placeholder="Component Source"
        options={componentSourceOptions}
        selectedOption={component_source}
        onSelect={(option) => { selectOptions("component_source", option) }} />
    </div>
    <div className="group-dropdown-container">
      <div className="drop-down-section">
        <MainInput
          disabled={true}
          onChange={(e) => {
          }}
          value={name}
          label={"Name"}
        />
      </div>
      <div className="drop-down-section">
        <span>Outputs</span>
        <MainDropDown
          placeholder="Choose an option"
          options={outputsOptions}
          selectedOption={output}
          onSelect={(option) => {
            setSelectedPorts((prev) => {
              let data = {
                ...prev,
                ["output"]: {
                  ...prev["output"],
                  [component_source]: {
                    ...prev["output"][component_source],
                    [option.value]: true,
                  }
                },
              }
              delete data["output"][component_source][output]
              return data;
            });
            selectOptions("output", option.value)
          }} />
      </div>
      <div className="drop-down-section">
        <span>Relay mode</span>
        <MainDropDown
          placeholder="Choose an option"
          options={relayModeOptions}
          selectedOption={relay_mode}
          onSelect={(option) => {
            selectOptions("relay_mode", option.value)
          }} />
      </div>
      <div className="lock-input-section">
        <MainInput
          disabled={relay_mode === 0}
          onChange={(text) => {
            if (impulseDurationValidation(text)) {
              selectOptions("impulse_time", text);
            } else {
              selectOptions("impulse_time", "2");
            }
          }}
          value={impulse_time}
          label={"Impulse Duration in seconds"}
        />
      </div>
      <div className="drop-down-section">
        <span>Type</span>
        <MainDropDown
          disabled={true}
          placeholder="Type"
          options={typeOptions}
          selectedOption={0}
          onSelect={(option) => { selectOptions("selectedType", option.value) }} />
      </div>
      <div className="lock-input-section">
        <MainInput
          type="number"
          onChange={(value) => {
            if (value === "0") {
              selectOptions("entry_exit_open_durations", 1);
              return
            }
            if (validateNumberRange(value)) {
              selectOptions("entry_exit_open_durations", value);
            } else {
              selectOptions("entry_exit_open_durations", value > 60 ? 60 : 0);
            }
          }}
          value={entry_exit_open_durations}
          label={"Hold Duration in seconds"}
        />
      </div>
      <div className="lock-input-section">
        <RadioButton label="Door sensor autolock" onChange={(value) => {
          selectOptions("sensorAutolock", !sensorAutolock)
        }}
          isSelected={sensorAutolock} />
      </div>
    </div>
  </div>;
}

export default OutputType;